import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const DeptShiftInfo = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        end_date: today,
        // must match the first <option> of each dropdown, otherwise the select
        // shows "All Company"/"All Employee" while the state is still empty
        department:"ALL",
		employeedet:"0"
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }



	const [empinfo, setEmpInfo] = useState({
        emp_id: "",
        shift_code: "",
        shift_date:"",
		user_id:"",
		emp_info:"",
    })




    const handelEditInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setEmpInfo({ ...empinfo, [name]: value });

        // if (event.target.value === '1') {
        //     setIsVisible(true);
        //   } else {
        //     setIsVisible(false);
        //   }
    }


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		let filteredItems = records.filter((item) =>
			`${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.dept_name.toLowerCase()}${item.shift_code.toLowerCase()}${item.shift_date.toLowerCase()}${item.shift_name.toLowerCase()}${item.day.toLowerCase()}${item.shift_time.toLowerCase()}${item.attendance_time.toLowerCase()}`.includes(searchTerm.toLowerCase())
		 
		);
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		const sortedItems = sortData(filteredItems);
	   const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	  const clearInput = () => {
		setSearchTerm("");
	  };


  useEffect(()=> {
	axios.get(API_BASE_URL +'/ajax_department_employee_info', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])






const handleSubmit = async (e) => {
    e.preventDefault();

	// alert(user.start_date);
	// alert(user.end_date);
	// alert(user.department);
	//  alert(user.employeedet);
	setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL +'/hodshiftinfo',
		{
			start_date: user.start_date,
			end_date: user.end_date,
			dept_id: user.department || "ALL",   // API requires dept_id ("ALL" or a numeric id)
			user_id: user.employeedet || "0",    // API requires user_id ("ALL"/"0" = every employee)
		},
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
//  console.log(response.data.shiftinfo);
      setRecords(response.data.shiftinfo); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
    setLoading(false);

    if (error.response && error.response.status === 422) {
      // Laravel validation errors
      const errors = error.response.data.errors;

      Object.values(errors).forEach((errMsg) => {
        toast.error(errMsg[0], {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});    // <-- Display each error message
      });
    } else {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  }
};

  // const paginate= (page) => setCurrentPage(page);

	const handleUpdate = async (shift_code) => {

		// alert(shift_code)
		axios.get(API_BASE_URL + '/edit_shift_info/' + shift_code, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		// .then(res1 => console.log(res1.data.shiftinfo[0]))
			.then(res1 => setEmpInfo(res1.data.shiftinfo[0]))
			.catch(err => console.log(err))
	};


	useEffect(()=> {
		axios.get(API_BASE_URL +'/fetchshift', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
	
		//.then(res =>console.log(res.data))
		 .then(res => setdataval(res.data))
		.catch(err => console.log(err));
	},[])


	const handleEditSubmit = (e) => {

		e.preventDefault();
		// alert(empinfo.emp_id);
		// alert(empinfo.shift_code);
		// alert(empinfo.shift_date);

		console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/update_shift_info', { emp_id: empinfo.emp_id, shift_code: empinfo.shift_code, attn_date: empinfo.shift_date }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const columns = [
  { label: "Employee Id", key: "employee_id", sortable: true },
  { label: "Employee", key: "employee_name", sortable: true },
  { label: "Department", key: "dept_name", sortable: true },
  { label: "Shift Code", key: "shift_code", sortable: true },
  { label: "Shift Name", key: "shift_name", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "Day", key: "day", sortable: true },
  { label: "Timing", key: "shift_time", sortable: true },
  { label: "Attendance", key: "attendance_time", sortable: true },
];

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>


					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														<div className="card-header d-flex justify-content-between align-items-center">
															<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
																<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
																	<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
																</svg>
																Duty Roster
															</h3>
														</div>
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">
															 <form onSubmit={handleSubmit} > 
					
																<div class="row align-items-end">

																<div className="col-lg col-md-6 col-sm-12">
																	<div className="form-group mb-2">
																	<label className="form-label">From Date</label>
																	<DatePicker
																		selected={user.start_date ? new Date(user.start_date) : null}
																		onChange={(date) => {
																			const value = date ? date.toLocaleDateString('en-CA') : "";
																			setUser(prev => ({ ...prev, start_date: value }));
																		}}
																		dateFormat="yyyy-MM-dd"
																		placeholderText="Select From Date"
																		className="form-control"
																		wrapperClassName="w-100"
																	/>
																	</div>
																</div>

																<div className="col-lg col-md-6 col-sm-12">
																	<div className="form-group mb-2">
																	<label className="form-label">To Date</label>
																	<DatePicker
																		selected={user.end_date ? new Date(user.end_date) : null}
																		onChange={(date) => {
																			const value = date ? date.toLocaleDateString('en-CA') : "";
																			setUser(prev => ({ ...prev, end_date: value }));
																		}}
																		dateFormat="yyyy-MM-dd"
																		placeholderText="Select To Date"
																		className="form-control"
																		wrapperClassName="w-100"
																		minDate={user.start_date ? new Date(user.start_date) : null}
																	/>
																	</div>
																</div>

																<div className="col-lg col-md-6 col-sm-12">
																	<div className="form-group mb-2">
																	<label className="form-label">Company</label>
																	<select className="form-control show-tick" name="department" value={user.department} onChange={handelInput} style={{ height: "38px" }}>
																	<option value="ALL">All Company</option>
																	<option value="0">Annai Arul Hospital</option>
																	</select>
																	</div>
																</div>

																<div className="col-lg col-md-6 col-sm-12">
																	<div className="form-group mb-2">
																	<label className="form-label">Employee</label>
																	<select className="form-control show-tick" value={user.employeedet} name="employeedet" onChange={handelInput} style={{ height: "38px" }}>
																	<option value="0">All Employee</option>
																	{data.map((option) => (
																		<option key={option.user_id} value={option.user_id}>
																		{option.first_name} {option.last_name} ({option.employee_id})
																		</option>
																	))}
																	</select>
																	</div>
																</div>

																<div className="col-lg-auto col-md-6 col-sm-12">
																	<div className="form-group mb-2">
																	<label className="form-label" style={{ visibility: "hidden" }}>Get</label>
																	<div>
																	<button type="submit" className="btn btn-primary">
																	GET
																	</button>
																	</div>
																	</div>
																</div>

																</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
																	<i className="fa fa-clock-o mr-2" style={{ fontSize: "20px" }} />
																	Shift List
																</h3>
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive sticky-table-wrap">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
																		<thead>
																			<tr>
																				<th>Action</th>
																			    {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																			</tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => {
                                                                                  
																					let action;
																					let shiftcode=`${record.user_id}---${record.shift_date}`;
																					
                                                           
                                                              if (record.curr_date_strtotime > record.shift_date_strtotime ){
                                                                    action = '';
                                                                  } else {
                                                                    action = <button type="button" onClick={() =>{ handleUpdate(shiftcode)}} className="btn btn-icon btn-sm" title="Edit" data-toggle="modal"
																	data-target="#exampleEditModal">
																	<i className="fa fa-edit" />
																	</button>;
																  }
                                                               return(

																					<tr key={record.employee_id}>
																					<td>{action}</td>	
																					<td>{record.employee_id}</td>
																					<td>{record.employee_name}</td>
																					<td>{record.dept_name}</td>
																					<td>{record.shift_code}</td>
																					<td>{record.shift_name}</td>
																					<td>{record.shift_date}</td>
																					<td>{record.day}</td>
																					<td>{record.shift_time}</td>
																					<td>{record.attendance_time}</td>
																				</tr>
															   )
																				
																				})
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>



			<div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Shift Info
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-4 col-sm-6">
										<div className="form-group">
										<label className="form-label">Employee Info<span className="form-required">*</span></label>
											<input type="text" className="form-control" name="emp_info" value={empinfo.emp_info}
												onChange={handelEditInput} placeholder="Url Name" readOnly/>
										<input type="hidden" name="emp_id" value={empinfo.emp_id}/>
										</div>
									</div>
									<div className="col-md-4 col-sm-6">
										<div className="form-group">
										<label className="form-label">Shift Date <span className="form-required">*</span></label>
											<input type="text" className="form-control" name="shift_date" value={empinfo.shift_date}
												onChange={handelEditInput} readOnly placeholder="" />
										</div>
									</div>

									<div className="col-md-4 col-sm-6">
									<div className="form-group">
									<label className="form-label">Shift Code <span className="form-required">*</span></label>
									<select name="shift_code" id="shift_code" className="form-control custom-select" value={empinfo.shift_code} onChange={handelEditInput}>
										
											{/* <option value="">ALL</option> */}
											{dataval.map(option => (
											<option key={option.shift_code} value={option.shift_code}>
												{option.shift_name}
											</option>
											))}
										</select>
                                    </div>
									</div>

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(DeptShiftInfo);